import { render } from "./InstrumentsDetails.vue?vue&type=template&id=6330c88a&scoped=true"
import script from "./InstrumentsDetails.vue?vue&type=script&lang=js"
export * from "./InstrumentsDetails.vue?vue&type=script&lang=js"

import "./InstrumentsDetails.vue?vue&type=style&index=0&id=6330c88a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6330c88a"]])

export default __exports__